export default __webpack_public_path__ + "static/media/logo.2fb5f6f1.png";